import { useQuery } from "@tanstack/react-query";

const useDashboardPermission = () => {
  const userLevel = localStorage.getItem("uILevel");

  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: dashboardPermissionData = [],
  } = useQuery({
    queryKey: ["dashboardPermission"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/link-permissions-get/${userLevel}`
        // "http://192.168.0.173/kyamch_ctms_backend_qa/api/dashboardStatistics"
      );
      const data = await res.json();
      localStorage.setItem("items2", JSON.stringify(data));
      return data;
    },
  });
  return [
    dashboardPermissionData,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
  ];
};

export default useDashboardPermission;
